module.exports = __webpack_public_path__ + "img/julian-pro.2a15140f.jpg";